import i18next from 'i18next';
import {
    CHANGE_LANGUAGE,
    SETUP_APP,
    SET_PAGE_TITLE,
} from '../actions/types';
import { getStorage, setStorage } from '../cache';

const INITIAL_STATE = {
    ready: !!i18next.language,
    language: i18next.language,
    languages: getStorage().languages,
    token: getStorage().token,
    pageTitle: '',
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CHANGE_LANGUAGE:
            return { ...state, language: action.payload, ready: !!action.payload };
        case SETUP_APP:
            setStorage({ token: action.payload.token, languages: action.payload.languages });
            return { ...state, token: action.payload.token, languages: action.payload.languages || state.languages };
        case SET_PAGE_TITLE:
            return { ...state, pageTitle: action.payload };
        default:
            return state;
    }
};
